import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const consolidado = async (id, opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl(`presupuestos-excel/${id}/consolidado`), { ...opciones, responseType: 'blob' });
};

const agrupado = async (id, opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl(`presupuestos-excel/${id}/agrupado`), { ...opciones, responseType: 'blob' });
};

const agrupadoPorMeses = async (id, opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl(`presupuestos-excel/${id}/agrupado-por-meses`), {
    ...opciones,
    responseType: 'blob',
  });
};

const consolidados = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('presupuestos-excel/consolidados'), { ...opciones, responseType: 'blob' });
};

const agrupadosConsolidados = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('presupuestos-excel/agrupado-consolidados'), {
    ...opciones,
    responseType: 'blob',
  });
};

const agrupadosPorMesesConsolidados = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('presupuestos-excel/agrupado-por-meses-consolidados'), {
    ...opciones,
    responseType: 'blob',
  });
};

const reporteEjecucionPresupuestaria = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('presupuestos-excel/reporte-ejecucion-presupuestaria'), {
    ...opciones,
    responseType: 'blob',
  });
};

const estimacionesReporte = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('estimaciones-excel/reporte'), { ...opciones, responseType: 'blob' });
};

const estimacionesReportesGlobales = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('estimaciones-excel/reportes-globales'), { ...opciones, responseType: 'blob' });
};

const estimacionesGestion = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('estimaciones-excel/gestion'), { ...opciones, responseType: 'blob' });
};

const solicitudesReporteTodos = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('solicitudes-excel/reporte-todos'), { ...opciones, responseType: 'blob' });
};

const solicitudesReporteConsolidadoSubtotales = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('solicitudes-excel/reporte-consolidado-subtotales'), {
    ...opciones,
    responseType: 'blob',
  });
};

const solicitudesReporteConsolidadoPorCuentaOrigen = async (opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl('solicitudes-excel/reporte-consolidado-por-cuenta-origen'), {
    ...opciones,
    responseType: 'blob',
  });
};

const conciliacionPorSede = async (sedeId, opciones = { params: {} }) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes-excel/conciliacion/sede/${sedeId}/excel`), {
    ...opciones,
    responseType: 'blob',
  });
};

export default {
  consolidado,
  agrupado,
  agrupadoPorMeses,
  consolidados,
  agrupadosConsolidados,
  agrupadosPorMesesConsolidados,
  estimacionesReporte,
  estimacionesReportesGlobales,
  estimacionesGestion,
  reporteEjecucionPresupuestaria,
  solicitudesReporteTodos,
  solicitudesReporteConsolidadoSubtotales,
  solicitudesReporteConsolidadoPorCuentaOrigen,
  conciliacionPorSede,
};
